"use client";

import styles from "@/styles/modules/components/tripleContent.module.scss";
import { TripleContentComponent } from "@/types/modules";
import Image from "next/image";

interface TripleContentProps {
  tripleContent: TripleContentComponent;
  tripleContentTitle: string;
}

export default function TripleContent({
  tripleContent,
  tripleContentTitle,
}: TripleContentProps) {
  return (
    <section className={styles.tripleContent}>
      <h2>{tripleContentTitle}</h2>
      {tripleContent.map((item, index) => (
        <article key={index} className={styles.tripleContentItem}>
          {item.image?.node?.link && (
            <Image
              src={item.image.node.link}
              alt={item.image.node.altText || "Imperial Riding School"}
              className={styles.tripleContentImage}
              width={item.image.node.mediaDetails.width}
              height={item.image.node.mediaDetails.height}
              data-aos="fade-in"
              data-aos-delay="200"
            />
          )}
          <h3 className={styles.tripleContentTitle}>{item.title}</h3>
          <p className={styles.tripleContentText}>{item.text}</p>
        </article>
      ))}
    </section>
  );
}
